
import React from 'react';
import { clsx } from 'clsx';

interface MetricCardProps {
  label: string;
  value: string | number;
  subValue?: string;
  variant?: 'light' | 'dark';
  status?: 'success' | 'warning' | 'danger' | 'neutral';
}

export const MetricCard: React.FC<MetricCardProps> = ({ 
  label, 
  value, 
  subValue, 
  variant = 'light',
  status = 'neutral' 
}) => {
  const statusColor = {
    success: 'text-emerald-500',
    warning: 'text-amber-500',
    danger: 'text-rose-500',
    neutral: variant === 'dark' ? 'text-white' : 'text-black'
  };

  return (
    <div className={clsx(
      "p-8 rounded-[2.5rem] border transition-all duration-500 min-w-0 group animate-in zoom-in-95 fade-in overflow-hidden flex flex-col justify-between h-full",
      variant === 'dark' 
        ? "bg-black border-zinc-800 shadow-2xl hover:border-zinc-600" 
        : "bg-white border-zinc-200 shadow-sm hover:shadow-xl hover:-translate-y-1"
    )}>
      <div>
        <p className={clsx(
          "text-[9px] font-black uppercase tracking-[0.2em] mb-4 truncate transition-opacity group-hover:opacity-100",
          variant === 'dark' ? "text-zinc-500 opacity-60" : "text-zinc-400 opacity-60"
        )}>{label}</p>
        <h3 className={clsx(
          "text-2xl md:text-3xl font-black tracking-tighter break-words tabular-nums leading-tight", 
          statusColor[status]
        )}>
          {value}
        </h3>
      </div>
      {subValue && (
        <p className={clsx(
          "text-[10px] mt-4 font-bold leading-tight transition-all line-clamp-2",
          variant === 'dark' ? "text-zinc-600 group-hover:text-zinc-400" : "text-zinc-400 group-hover:text-zinc-600"
        )}>{subValue}</p>
      )}
    </div>
  );
};
